import axios from "axios";



const instance = axios.create({

    // baseURL: "http://dd-elite:8085/api/",
    // baseURL: "http://10.113.243.174:8083/api/",
    baseURL: "https://portail.ipm-africmanagement.com/office/api/",
    // baseURL: "https://portail.ipmpetitecote.com/office/api/",
    // baseURL: "https://portail.ipmics.com/office/api/",
    // baseURL: "https://portail.ipmsagam.com/office/api/",
    // baseURL: "https://portail.ipmipres.com/office/api/",
    // baseURL: "https://portail.ipmubipharm.com/office/api/",
    // baseURL: "https://portail.ipmeiffage.com/office/api/",
});

// instance.defaults.headers.common['perim'] = `${user_connect.prenom} ${user_connect.nom}`;

export default instance;